import React from "react";
import { Link } from "react-router-dom";

import { LEGAL_CONFIG } from "./legal-config";
import { LegalPage, LegalSection } from "./legal-page";

const Terms: React.FC = () => {
  return (
    <LegalPage
      title="Regulamin"
      lead={`Na jakich zasadach działa serwis ${LEGAL_CONFIG.serviceName}, co możesz w nim robić i czego od nas oczekiwać.`}
    >
      <LegalSection id="uslugodawca" number="1" title="Kto świadczy usługę">
        <p>
          Usługodawcą jest <strong>{LEGAL_CONFIG.administratorName}</strong>,{" "}
          {LEGAL_CONFIG.administratorAddress}, {LEGAL_CONFIG.contactEmail}. Serwis
          dostępny jest pod adresami {LEGAL_CONFIG.serviceDomains.join(" i ")}.
        </p>
        <p>
          Serwis prowadzony jest niezarobkowo, przez osobę fizyczną nieprowadzącą
          działalności gospodarczej. Korzystanie z niego jest bezpłatne — nie pobieramy
          opłat ani od zawodników, ani od organizatorów.
        </p>
      </LegalSection>

      <LegalSection id="zakres" number="2" title="Co robi serwis">
        <p>
          Serwis prowadzi ranking zawodników badmintona wyliczany metodą ELO na podstawie
          wyników meczów, publikuje wyniki i klasyfikacje sezonowe oraz udostępnia
          organizatorom lig narzędzia do prowadzenia zapisów, dobierania par i wpisywania
          wyników.
        </p>
        <p>
          Serwis <strong>nie organizuje rozgrywek</strong> — robią to kluby
          i organizatorzy, działający na własny rachunek i na własną odpowiedzialność.
        </p>
      </LegalSection>

      <LegalSection id="uslugi" number="3" title="Rodzaje usług i moment zawarcia umowy">
        <ul>
          <li>
            <strong>Przeglądanie</strong> rankingów, wyników i klasyfikacji nie wymaga
            konta ani podania danych. Umowa zawierana jest z chwilą wejścia na stronę
            i rozwiązuje się z chwilą jej opuszczenia.
          </li>
          <li>
            <strong>Konto użytkownika</strong> — umowa zawierana jest z chwilą
            potwierdzenia rejestracji, na czas nieokreślony.
          </li>
          <li>
            <strong>Zapis na kolejkę</strong> — umowa zawierana jest z chwilą wysłania
            formularza zapisu, także bez konta, przez link udostępniony przez
            organizatora. Rozwiązuje się z chwilą rozliczenia kolejki.
          </li>
          <li>
            <strong>Panel organizatora</strong> — dostępny dla kont, którym nadano rolę
            organizatora.
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="wymagania" number="4" title="Wymagania techniczne">
        <p>
          Do korzystania z serwisu potrzebne są: urządzenie z dostępem do internetu,
          aktualna przeglądarka obsługująca JavaScript oraz włączona obsługa pamięci
          lokalnej przeglądarki (localStorage). Bez pamięci lokalnej działa przeglądanie,
          ale nie da się zalogować.
        </p>
        <p>
          Serwis nie wysyła wiadomości e-mail. Adres podany przy rejestracji służy
          wyłącznie jako login i nie jest weryfikowany.
        </p>
      </LegalSection>

      <LegalSection id="zakazy" number="5" title="Czego nie wolno">
        <p>
          Zakazane jest dostarczanie treści bezprawnych, w szczególności:
        </p>
        <ul>
          <li>
            wpisywanie w polach tekstowych — w tym w notatce w puli „szukam partnera” —
            treści obraźliwych, wulgarnych, naruszających dobra osobiste innych osób albo
            stanowiących dane osobowe osób trzecich podane bez ich wiedzy,
          </li>
          <li>podszywanie się pod inną osobę przy zapisie na kolejkę,</li>
          <li>zgłaszanie nieprawdziwych wyników meczów,</li>
          <li>
            automatyczne pobieranie zawartości serwisu w sposób obciążający serwer ponad
            zwykłe korzystanie,
          </li>
          <li>
            próby uzyskania dostępu do cudzych kont, do panelu organizatora lub do danych
            kontaktowych uczestników.
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="ranking" number="6" title="Ranking i wyniki">
        <ol>
          <li>
            Rating ELO wyliczany jest automatycznie, wyłącznie na podstawie wyników
            meczów, według jednakowej dla wszystkich reguły.
          </li>
          <li>
            Wyniki pochodzą od organizatorów rozgrywek — wpisane w serwisie albo pobrane
            z ich publicznych stron. Usługodawca nie weryfikuje ich prawidłowości.
          </li>
          <li>
            Wynik meczu dotyczy równocześnie wszystkich jego uczestników, dlatego
            usunięcie pojedynczego wyniku z historii nie jest możliwe bez zafałszowania
            ratingu pozostałych zawodników. Zasady postępowania ze sprzeciwem wobec
            publikacji nazwiska opisuje punkt 8{" "}
            <Link to="/prywatnosc">polityki prywatności</Link>.
          </li>
          <li>
            Błąd w wyniku zgłoś na {LEGAL_CONFIG.contactEmail}, wskazując turniej i mecz —
            sprostujemy go i przeliczymy rating ponownie.
          </li>
        </ol>
      </LegalSection>

      <LegalSection id="odpowiedzialnosc" number="7" title="Odpowiedzialność">
        <p>
          Serwis udostępniany jest w takim stanie, w jakim jest, nieodpłatnie
          i niezarobkowo. Usługodawca dokłada starań, by działał nieprzerwanie, ale nie
          gwarantuje ciągłości działania ani bezbłędności danych i zastrzega sobie prawo
          do przerw technicznych.
        </p>
        <p>
          Usługodawca nie odpowiada za decyzje organizatorów rozgrywek — w szczególności
          za dopuszczenie lub niedopuszczenie zawodnika do gry — ani za przebieg samych
          rozgrywek.
        </p>
      </LegalSection>

      <LegalSection id="reklamacje" number="8" title="Reklamacje">
        <p>
          Reklamację złóż na <strong>{LEGAL_CONFIG.contactEmail}</strong>, podając czego
          dotyczy i jakiego rozstrzygnięcia oczekujesz. Odpowiadamy w terminie 14 dni na
          adres, z którego reklamacja wpłynęła.
        </p>
      </LegalSection>

      <LegalSection id="rozwiazanie" number="9" title="Odstąpienie i rozwiązanie umowy">
        <ol>
          <li>
            Konto możesz usunąć w każdej chwili, bez podania przyczyny, pisząc na{" "}
            {LEGAL_CONFIG.contactEmail}. Jest to równoznaczne z rozwiązaniem umowy ze
            skutkiem natychmiastowym. Skutki dla danych opisuje punkt 6{" "}
            <Link to="/prywatnosc">polityki prywatności</Link> — dane kontaktowe znikają,
            wyniki sportowe pozostają.
          </li>
          <li>
            Konsumentowi przysługuje prawo odstąpienia od umowy zawartej na odległość
            w terminie 14 dni bez podania przyczyny.
          </li>
          <li>
            Usługodawca może rozwiązać umowę z 14-dniowym wypowiedzeniem, a w razie
            rażącego naruszenia punktu 5 — zablokować konto ze skutkiem natychmiastowym,
            informując o przyczynie.
          </li>
        </ol>
      </LegalSection>

      <LegalSection id="zmiany" number="10" title="Zmiany regulaminu">
        <p>
          O zmianie regulaminu poinformujemy w serwisie co najmniej 14 dni przed wejściem
          zmiany w życie. Jeżeli nie akceptujesz zmiany, możesz w tym czasie usunąć konto.
        </p>
      </LegalSection>

      <LegalSection id="dane-osobowe" number="11" title="Dane osobowe">
        <p>
          Zasady przetwarzania danych osobowych opisuje odrębna{" "}
          <Link to="/prywatnosc">polityka prywatności</Link>, a informacje o pamięci
          przeglądarki — <Link to="/cookies">informacja o plikach cookie</Link>.
        </p>
      </LegalSection>

      <LegalSection id="koncowe" number="12" title="Postanowienia końcowe">
        <p>
          W sprawach nieuregulowanych stosuje się prawo polskie, w szczególności ustawę
          o świadczeniu usług drogą elektroniczną, ustawę o prawach konsumenta i Kodeks
          cywilny. Regulamin obowiązuje od {LEGAL_CONFIG.lastUpdated}.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default Terms;
